import React from 'react';
import { getdimensionVideoList } from '../services/DimensionClassService';
import {
  DimensionClassAction,
  DimensionClassStateType,
} from './useDimensionClassReducer';

export async function loadFirstPage(
  dispatch: React.Dispatch<DimensionClassAction>,
  languageCode: string,
) {
  const payload = { pageNumber: 1 };
  try {
    dispatch({ type: DimensionClassStateType.LOADING, payload: payload });
    const videoList = await getdimensionVideoList(1, languageCode);
    dispatch({
      type: DimensionClassStateType.LOADED,
      payload: { ...payload, videoList: videoList },
    });
  } catch (exception) {
    dispatch({ type: DimensionClassStateType.ERROR, payload: payload });
  }
}

export async function loadNextPage(
  dispatch: React.Dispatch<DimensionClassAction>,
  pageNumber: number,
  languageCode: string,
) {
  const payload = { pageNumber: pageNumber };
  try {
    dispatch({ type: DimensionClassStateType.LOAD_MORE, payload: payload });
    const videoList = await getdimensionVideoList(pageNumber, languageCode);
    dispatch({
      type: DimensionClassStateType.LOADED,
      payload: { ...payload, videoList: videoList },
    });
  } catch (exception) {
    dispatch({ type: DimensionClassStateType.ERROR, payload: payload });
  }
}
